var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { SurveyQuestionElementBase } from "./reactquestion_element";
import { ReactQuestionFactory } from "./reactquestion_factory";
import { ReactElementFactory } from "./element-factory";
var SurveyQuestionSlider = /** @class */ (function (_super) {
    __extends(SurveyQuestionSlider, _super);
    function SurveyQuestionSlider(props) {
        var _this = _super.call(this, props) || this;
        _this.rangeInputRef = React.createRef();
        return _this;
    }
    SurveyQuestionSlider.prototype.componentDidMount = function () {
        _super.prototype.componentDidMount.call(this);
        this.question.refreshInputRange(this.rangeInputRef.current);
    };
    Object.defineProperty(SurveyQuestionSlider.prototype, "question", {
        get: function () {
            return this.questionBase;
        },
        enumerable: false,
        configurable: true
    });
    SurveyQuestionSlider.prototype.getStateElement = function () {
        return this.question;
    };
    SurveyQuestionSlider.prototype.renderElement = function () {
        var _this = this;
        var _a = this.question, cssClasses = _a.cssClasses, showLabels = _a.showLabels, sliderType = _a.sliderType, getTrackPercentLeft = _a.getTrackPercentLeft, getTrackPercentRight = _a.getTrackPercentRight, allowDragRange = _a.allowDragRange, setValueByClickOnPath = _a.setValueByClickOnPath;
        var rangeInput = (sliderType === "single" && allowDragRange) ? null : this.getRangeInput();
        var thumbsAndInputs = this.getInputsAndThumbs();
        var labels = showLabels ? this.getLabels() : null;
        return (React.createElement("div", { className: this.question.rootCss, ref: function (div) { return (_this.setControl(div)); } },
            rangeInput,
            React.createElement("div", { className: cssClasses.visualContainer, onPointerUp: function (e) { setValueByClickOnPath(e.nativeEvent, _this.control); } },
                React.createElement("div", { className: cssClasses.visualContainerSlider },
                    React.createElement("div", { className: cssClasses.inverseTrackLeft, style: { width: getTrackPercentLeft() + "%" } }),
                    React.createElement("div", { className: cssClasses.inverseTrackRight, style: { width: getTrackPercentRight() + "%" } }),
                    React.createElement("div", { className: cssClasses.rangeTrack, style: { left: getTrackPercentLeft() + "%", right: getTrackPercentRight() + "%" } }),
                    thumbsAndInputs)),
            labels));
    };
    SurveyQuestionSlider.prototype.getInputsAndThumbs = function () {
        var inputsAndThumbs = [];
        var value = this.question.renderedValue;
        for (var i = 0; i < value.length; i++) {
            var thumbAndInput = React.createElement(React.Fragment, { key: i },
                this.getInput(i),
                this.getThumb(i));
            inputsAndThumbs.push(thumbAndInput);
        }
        return inputsAndThumbs;
    };
    SurveyQuestionSlider.prototype.getThumb = function (i) {
        var _a = this.question, cssClasses = _a.cssClasses, getThumbContainerCss = _a.getThumbContainerCss, tooltipVisibility = _a.tooltipVisibility, tooltipCss = _a.tooltipCss, getPercent = _a.getPercent, renderedValue = _a.renderedValue, getTooltipValue = _a.getTooltipValue;
        var value = renderedValue[i];
        var tooltip = null;
        if (tooltipVisibility !== "never") {
            tooltip = React.createElement("div", { className: tooltipCss },
                React.createElement("div", { className: cssClasses.tooltipPanel },
                    React.createElement("div", { className: cssClasses.tooltipValue }, getTooltipValue(i))));
        }
        var thumb = React.createElement("div", { className: getThumbContainerCss(i), style: { left: getPercent(value) + "%" } },
            tooltip,
            React.createElement("div", { className: cssClasses.thumb },
                React.createElement("div", { className: cssClasses.thumbDot })));
        return thumb;
    };
    SurveyQuestionSlider.prototype.getInput = function (i) {
        var _a = this.question, max = _a.renderedMax, min = _a.renderedMin, step = _a.step, cssClasses = _a.cssClasses, isDisabledAttr = _a.isDisabledAttr, renderedValue = _a.renderedValue, handleOnChange = _a.handleOnChange, handlePointerDown = _a.handlePointerDown, handlePointerUp = _a.handlePointerUp, handleKeyDown = _a.handleKeyDown, handleKeyUp = _a.handleKeyUp, handleOnFocus = _a.handleOnFocus, handleOnBlur = _a.handleOnBlur, id = _a.id;
        var value = renderedValue[i];
        var input = React.createElement("input", { className: cssClasses.input, id: id + "-sjs-slider-input-" + i, type: "range", min: min, max: max, step: step, value: value, onChange: function (e) { handleOnChange(e.nativeEvent, i); }, onPointerDown: function (e) { handlePointerDown(e.nativeEvent); }, onPointerUp: function (e) { e.stopPropagation(); handlePointerUp(e.nativeEvent); }, onKeyDown: function (e) { handleKeyDown(e.nativeEvent); }, onKeyUp: function (e) { handleKeyUp(e.nativeEvent); }, onFocus: function () { handleOnFocus(i); }, onBlur: function () { handleOnBlur(); }, disabled: isDisabledAttr, "aria-required": this.question.a11y_input_ariaRequired, "aria-label": this.question.a11y_input_ariaLabel, "aria-labelledby": this.question.a11y_input_ariaLabelledBy, "aria-describedby": this.question.a11y_input_ariaDescribedBy, "aria-invalid": this.question.a11y_input_ariaInvalid, "aria-errormessage": this.question.a11y_input_ariaErrormessage });
        return input;
    };
    SurveyQuestionSlider.prototype.getRangeInput = function () {
        var _this = this;
        var _a = this.question, max = _a.renderedMax, min = _a.renderedMin, step = _a.step, cssClasses = _a.cssClasses, handleRangeOnChange = _a.handleRangeOnChange, handleRangePointerDown = _a.handleRangePointerDown, handleRangePointerUp = _a.handleRangePointerUp, id = _a.id;
        return React.createElement("input", { name: "range-input", id: id + "-sjs-slider-input-range-input", ref: this.rangeInputRef, className: cssClasses.input, type: "range", "aria-hidden": "true", min: min, max: max, step: step, tabIndex: -1, onChange: function (e) { handleRangeOnChange(e.nativeEvent); }, onPointerDown: function (e) { e.persist(); handleRangePointerDown(e.nativeEvent, _this.control); }, onPointerUp: function (e) { handleRangePointerUp(e.nativeEvent, _this.control); } });
    };
    SurveyQuestionSlider.prototype.getLabels = function () {
        var labels = [];
        var _a = this.question, renderedLabels = _a.renderedLabels, cssClasses = _a.cssClasses;
        for (var i = 0; i < renderedLabels.length; i++) {
            var label = ReactElementFactory.Instance.createElement("sv-slider-label-item", { item: renderedLabels[i], question: this.question, key: renderedLabels[i].id });
            labels.push(label);
        }
        return React.createElement("div", { className: cssClasses.labelsContainer },
            React.createElement("div", null, labels));
    };
    return SurveyQuestionSlider;
}(SurveyQuestionElementBase));
export { SurveyQuestionSlider };
ReactQuestionFactory.Instance.registerQuestion("slider", function (props) {
    return React.createElement(SurveyQuestionSlider, props);
});
